import { ModuleCommandEnum } from "@/types/enums/module-command.enum";
import { ArrowDirectionEnum } from "../enums/arrow-directon.enum";

export const getArrowForAction = (action: ModuleCommandEnum) => {
  let resultArrow: ArrowDirectionEnum | null = null;

  switch (action) {
    case ModuleCommandEnum.UP:
      return ArrowDirectionEnum.UP;
    case ModuleCommandEnum.DOWN:
      return ArrowDirectionEnum.DOWN;
    case ModuleCommandEnum.OPEN:
      return ArrowDirectionEnum.OPEN;
    case ModuleCommandEnum.CLOSE:
      return ArrowDirectionEnum.CLOSE;
  }
  if (!resultArrow) {
    throw new Error("No arrow found");
  }
  return resultArrow;
};
